import styled from 'styled-components';
import Text from 'shared/components/Text/Text';

export const SuccessBodyHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const HeaderText = styled(Text)`
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  display: inline;
  word-break: break-word;
`;

export const SuccessModalBodyContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 0px 16px 0px;
    width: auto;
    align-self: center;
    @media screen and (min-width: ${theme.breakpoints.small}) {
      padding: 20px 18px 16px 18px;
      width: 100%
    }
`}
`;
